/**
 * @praesto/core/internal/context
 *
 * Module-private runtime context shared by every subsystem. `tenantId` is the
 * fail-closed anchor of multi-tenancy: it is derived from the tenant slug /
 * the authenticated user's `tenantId` claim, NEVER from a caller argument
 * (root CLAUDE.md). Phase 2 subsystems read Firebase handles from here.
 */
import type { FirebaseHandles } from "./firestore";

export interface RuntimeContext {
  readonly tenantId: string;
  readonly firebase: FirebaseHandles;
}

export function createRuntimeContext(tenantId: string, firebase: FirebaseHandles): RuntimeContext {
  if (tenantId.trim() === "") {
    throw new Error("[core] RuntimeContext requires a non-empty tenantId");
  }
  return Object.freeze({ tenantId, firebase });
}
